(function () {
  // Shopify's cookiebanner verschijnt op deze winkel niet vanzelf: boot() en
  // loadBanner() doen niets, alleen showBanner() toont hem. Daarom tonen we hem
  // zelf, met remmen zodat een bezoeker hem nooit twee keer krijgt:
  //   1. alleen als Shopify zegt dat toestemming nog ontbreekt
  //   2. alleen als er nog geen _tracking_consent-cookie is
  //   3. hoogstens een keer per browsersessie
  // Belangrijk: de sessierem wordt PAS gezet als de banner echt in beeld staat.
  // Zo kan een mislukte poging een bezoeker niet de rest van de sessie
  // zonder banner laten zitten.
  var KEY = 'cs_consent_banner_shown';

  function heeftConsentCookie() {
    return document.cookie.indexOf('_tracking_consent') !== -1;
  }

  function alGetoond() {
    try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function markeerGetoond() {
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function bannerStaatErNu() {
    var el = document.getElementById('shopify-pc__banner');
    if (!el) { return false; }
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  // Controleert na het tonen of de banner er echt staat. Pas dan de rem zetten.
  function bevestig(pogingen) {
    if (bannerStaatErNu()) { markeerGetoond(); return; }
    if (pogingen > 0) { setTimeout(function () { bevestig(pogingen - 1); }, 300); }
  }

  var tries = 0;
  function toon() {
    tries++;
    if (bannerStaatErNu()) { markeerGetoond(); return; }
    var pb = window.privacyBanner;
    if (!pb || typeof pb.showBanner !== 'function') {
      if (tries < 60) { setTimeout(toon, 250); }
      return;
    }
    try { if (typeof pb.boot === 'function') { pb.boot(); } } catch (e) {}
    setTimeout(function () {
      try { pb.showBanner(); } catch (e) {}
      bevestig(20);
    }, 300);
  }

  var startTries = 0;
  function start() {
    startTries++;
    if (heeftConsentCookie() || alGetoond()) { return; }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      if (startTries < 60) { setTimeout(start, 250); }
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) { return; }
        if (heeftConsentCookie() || alGetoond()) { return; }
        try {
          var cp = window.Shopify.customerPrivacy;
          if (!cp || typeof cp.shouldShowBanner !== 'function') { return; }
          if (!cp.shouldShowBanner()) { return; }
          toon();
        } catch (e) {}
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
